// @flow strict

import * as React from 'react';
import BaseColumn from '../BaseColumn';
import styles from './styles.scss';
import { Link } from '../../../Button';

type PropTypes = {|
  imageSize?: 'Small' | 'Medium',
  image: string,
  title: React.Node,
  meta?: React.Node,
  text?: string,
  ctaText: string,
  ctaHref: string,
  className?: string,
  variant?: 'Default' | 'Dark',
  switchedTitle?: boolean,
|};

export default (props: PropTypes) => {
  return (
    <BaseColumn image={props.image} imageSize={props.imageSize} className={props.className}>
      {!props.switchedTitle && props.meta && <p className={styles.meta}>{props.meta}</p>}
      <h3 className={styles.title}>{props.title}</h3>
      {props.switchedTitle && props.meta && <p className={styles.meta}>{props.meta}</p>}
      <p className={styles.text}>{props.text}</p>
      <Link
        href={props.ctaHref}
        variant={props.variant === 'Dark' ? 'UnderlineDark' : 'Underline'}
        className={styles.cta}
      >
        {props.ctaText}
      </Link>
    </BaseColumn>
  );
};
